import { KeyValue } from "../../home/models/OtherTypes";
import { createUserRolesInfo, UserRolesModel } from "./UserRolesInfo";

export enum AccountProvider {
    email = 0, phone = 1
}
export interface AccountModel {
    userId: string;
    isConfirmed: boolean;
    options: KeyValue<string, AccountProvider>[];
}

export interface TokenResource {
    token: string;
    expiry: number;
}

export interface AuthTokensInfo {
    userId: string;
    isConfirmed: boolean;
    accessToken: TokenResource;
    refreshToken: TokenResource;
    userRoles: UserRolesModel;
}

export const createTokenResource = (): TokenResource => ({
    token: "",
    expiry: 0
});

export const createAuthTokensInfo = (): AuthTokensInfo => ({
    userId: "",
    isConfirmed: false,
    accessToken: createTokenResource(),
    refreshToken: createTokenResource(),
    userRoles: createUserRolesInfo()
});

export interface AccountPhoneModel {
    countryCode: string;
    phoneNo: string;
    telegram: boolean;
}

export interface LoginModel extends AccountPhoneModel {
    provider: AccountProvider;
    email?: string;
    password: string;
    rememberMe: boolean;
}

export interface SignupModel extends LoginModel {
    firstName: string;
    lastName: string;
    displayName: string;
    isMobile: boolean;
    isLocal: boolean;
}

export interface ForgotPasswordModel extends AccountPhoneModel {
    isByEmail: boolean;
    email: string;
}

export interface ResetPasswordModel {
    code: string;
    userId: string;
    password: string;
}

export interface EmailForgotPasswordModel {
    email: string;
}

export interface AccountConfirmModel extends AccountModel {
    code: string;
    password: string;
}

export interface ChangePasswordModel {
    currentPassword: string;
    newPassword: string;
}